import { call, put, all, takeLatest, select } from 'redux-saga/effects';

import { updateBulkTaskFailure } from './taskActions';
import api from '../../api/api';

import { TOAST_TYPES } from '../../common';
import TRANSLATE_KEYS from '../../public/locales/translateKeys';
import { generateToastMessage } from '../../utils/generalUtils';
import { UPDATE_BULK_TASK_REQUEST } from './taskActionTypes';
import { getPageSize } from '../userPreferences/userPreferencesSelector';
import { getWorkflowQueryParams } from '../worklist/worklistSelector';
import { GetWorklistActionTypes } from '../worklist/worklistActionTypes';


const getSuccessToastMessage = (attribute: string) => {
  switch(attribute) {
    case 'isActive': 
     return 'The Archive status was successfully updated for all selected tasks';
    case 'readFlag':
      return 'The Read status was successfully updated for all selected tasks';
    default: 
      return TRANSLATE_KEYS.toast_messages.successful.successful_reassign_task;
  }
}

const getFailureToastMessage = (attribute: string) => {
  switch(attribute) {
    case 'isActive': 
     return 'The Archive status was not updated for all selected tasks';
    case 'readFlag':
      return 'The Read status was not updated for all selected tasks';
    default: 
      return '';
  }
}

const isAttributeArchiveOrReadStatus = (attribute: string) => {
  return attribute === 'isActive' || attribute === 'readFlag';
}

export function* updateBulkTaskRequest(action: any) {
  const attribute = action.payload.updateAttribute;
  try {
    const res = yield call(api.task.updateBulkTasks, action.payload.updateItems);
    if(isAttributeArchiveOrReadStatus(attribute) && res.status === 200) {
      yield put(generateToastMessage( TOAST_TYPES.success, getSuccessToastMessage(attribute)));
      const pageSize = yield select(getPageSize);
      const queryParams = yield select(getWorkflowQueryParams);
      yield put({ type: GetWorklistActionTypes.GET_WORKLIST_REQUEST, payload: { pageSize, ...queryParams}});
    } else if(attribute === 'reassign') {
      yield put(generateToastMessage(TOAST_TYPES.success, getSuccessToastMessage('reassign')));
    }
  } catch (err) {
    if(isAttributeArchiveOrReadStatus(attribute)) {
      yield put(generateToastMessage(TOAST_TYPES.error, getFailureToastMessage(attribute)));
    }
    // @ts-ignore -- present error if avaialable
    yield put(updateBulkTaskFailure(err?.response?.data?.message));
  }
}

export default function* rootSaga() {
  yield all([takeLatest(UPDATE_BULK_TASK_REQUEST, updateBulkTaskRequest)]);
}
